import React, { useState, useEffect } from "react";
import { Box, TextField, Typography, Card } from "@mui/material";
import { useTranslation } from "react-i18next";

import { getUserLineEmail, updateUserEmail } from "utils/api";
import StyledButton from "./StyledButton";
import Loading from "./Loading";
import { COLORS } from "constants/colors";

function InputEmail({ onClickPurchase, updateEmailFn }) {
  const { t } = useTranslation(["common"]);

  const [isLoading, setIsLoading] = useState(true);
  const [email, setEmail] = useState("");
  const [confirmEmail, setConfirmEmail] = useState("");
  const [errorMessage, setErrorMessage] = useState(null);
  const [confirmErrorMessage, setConfirmErrorMessage] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const handleClick = async () => {
    let hasError = false;

    if (email === "") {
      // setErrorMessage("メールアドレスを入力してください。");
      setErrorMessage(t("common:email.error.required"));
      hasError = true;
    } else if (!email.includes("@")) {
      // setErrorMessage("正しいメールアドレスの形式で入力してください。");
      setErrorMessage(t("common:email.error.invalid"));
      hasError = true;
    } else {
      setErrorMessage(null);
    }

    if (confirmEmail !== email) {
      // setConfirmErrorMessage("メールアドレスが一致しません。");
      setConfirmErrorMessage(t("common:email.error.no_match"));
      hasError = true;
    } else {
      setConfirmErrorMessage(null);
    }

    if (hasError) return;

    setIsProcessing(true);
    try {
      const updateFn = updateEmailFn || updateUserEmail;
      await updateFn(email, false);
    } catch (error) {
      setIsProcessing(false);
      return;
    }

    onClickPurchase();
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };

  const handleConfirmEmailChange = (event) => {
    setConfirmEmail(event.target.value);
  };

  useEffect(() => {
    const initEmail = async () => {
      const email = await getUserLineEmail();
      setEmail(email);
      setConfirmEmail(email); // 初期値を確認欄にも設定
      setIsLoading(false);
    };

    initEmail();
  }, []);

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
      }}
    >
      <Card
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 4,
          mb: 4,
          minWidth: 300,
        }}
      >
        <Typography
          sx={(theme) => ({
            color: COLORS.TEXT_BLACK,
            fontSize: "16px",
            fontWeight: "bold",
          })}
        >
          {/* メールアドレスを登録してください */}
          {t("common:email.info.register")}
        </Typography>

        <Typography
          sx={(theme) => ({
            color: COLORS.TEXT_BLACK,
            fontSize: "12px",
            textAlign: "center",
            mt: 2,
          })}
        >
          {/* メールアドレスは本サービス利用に関する大事なお知らせをお届けする目的で利用いたします。 */}
          {t("common:email.info.usage")}
        </Typography>

        <TextField
          id="email"
          label="メールアドレス"
          variant="outlined"
          value={email}
          error={errorMessage !== null}
          helperText={errorMessage}
          onChange={handleEmailChange}
          required
          sx={{
            width: "90%",
            marginTop: 6,
            "& .MuiInputBase-input": {
              color: COLORS.TEXT_BLACK,
              fontSize: "16px",
            },
            "& .MuiInputLabel-root": {
              color: COLORS.TEXT_BLACK,
              "&.Mui-focused": {
                color: COLORS.TEXT_BLACK,
              },
            },
          }}
        />

        <TextField
          id="confirm-email"
          label="メールアドレス（確認用）"
          variant="outlined"
          value={confirmEmail}
          error={confirmErrorMessage !== null}
          helperText={confirmErrorMessage}
          onChange={handleConfirmEmailChange}
          required
          sx={{
            width: "90%",
            marginTop: 3,
            "& .MuiInputBase-input": {
              color: COLORS.TEXT_BLACK,
              fontSize: "16px",
            },
            "& .MuiInputLabel-root": {
              color: COLORS.TEXT_BLACK,
              "&.Mui-focused": {
                color: COLORS.TEXT_BLACK,
              },
            },
          }}
        />

        <StyledButton
          variant="contained"
          sx={{
            width: "70%",
            mt: 4,
            color: COLORS.TEXT_BLACK,
            border: `2px solid ${COLORS.TEXT_BLACK}`,
          }}
          onClick={handleClick}
          disabled={isProcessing}
        >
          {/* 登録して購入に進む */}
          {t("common:button.register_and_purchase")}
        </StyledButton>
      </Card>
    </Box>
  );
}

export default InputEmail;
